export default __webpack_public_path__ + "static/media/donna-fraser.7aed22a8.png";